import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import LoginForm from '../@react-fefmwk/auth/modules/LoginForm'
import AdapterLink from '../@react-fefmwk/links/modules/AdapterLink'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
//import Button from '@material-ui/core/Button'

import { NavTopTitle } from '../services/NavTopSchema'

const styles = {
    cardContent: {
        paddingTop: 4,
        paddingBottom: 4,
        "&:last-child": {
            paddingBottom: 4
        }
    },
    cleanLink: {
        textDecoration: 'none',
        color: 'grey'
    }
}

class Login extends React.Component {
    render() {
        const redirectTo = this.props.route.hasOwnProperty('redirectTo')
            ? this.props.route.redirectTo
            : "/apps"

        const { classes } = this.props

        return <Card>
            <Box bgcolor="secondary.500" color="white" component="div" width="100%">
                <CardContent className={classes.cardContent}>
                    <Grid container direction="row"
                        spacing={0}
                        alignItems="center"
                        justify="flex-start"
                    >
                        <Grid item>
                            <img className="LogoImg" src="/images/logo-login.png" alt="Logo" style={{maxWidth:40}} />
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" color="inherit" className="appTitle">
                                {NavTopTitle}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Box>
            <CardContent>
                <LoginForm redirectTo={redirectTo} onValidate={(values,errors) => {
                    const username = values.hasOwnProperty('username') ? values.username : ''
                    const password = values.hasOwnProperty('password') ? values.password : ''
                    if( username && username.length < 6 )
                        errors['username'] = 'User name is too short'
                    if( password && password.length < 6 )
                        errors['password'] = 'Password is too short'

                    return errors
                }} />
                {/* <Box mt={2}>
                    <Typography variant="caption" component={AdapterLink} to="/forgot-password" className={classes.cleanLink}>
                        Password dimenticata?
                    </Typography>
                </Box> */}
            </CardContent>
        </Card>
    }
}

export default withStyles(styles)(Login)